/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { RichText, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import IsRtl from "components/Shared/isRtl";
import { ComponentProps } from "lib/component-props";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { DGAButton } from "components/Shared/dga-button/DGAButton";
import DGADropdownInput from "components/Shared/DGA-inputs/DGA-dropdown-input";

type MoveablePlatformProps = ComponentProps & {
  fields: {
    Title: {
      value: string;
    };
    Description: {
      value: string;
    };
    SortButtonText: {
      value: string;
    };
    NoDataFoundText: {
      value: string;
    };
    DetailsColumnTitle: {
      value: string;
    };
    ShowDetailsColumn: {
      value: boolean;
    };
    PostingDateColumnTitle: {
      value: string;
    };
    ShowPostingDateColumn: {
      value: boolean;
    };
    IDColumnTitle: {
      value: string;
    };
    DetailsFieldButtonText: {
      value: string;
    };
    Rows: {
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        PostingDate: {
          value: string;
        };
        FileLink: {
          value: {
            src: string;
            name: string;
            displayName: string;
            title: string;
            keywords: string;
            description: string;
            extension: string;
            mimeType: string;
          };
        };
        RowFields: {
          id: string;
          url: string;
          name: string;
          displayName: string;

          fields: {
            Type: {
              id: string;
              url: string;
              name: string;
              displayName: string;
              fields: {
                Title: {
                  value: string;
                };
              };
            };
            DateValue?: {
              value: string;
            };
            Title?: {
              value: string;
            };
          };
        }[];
      };
    }[];
    Columns: {
      id: string;
      url: string;
      name: string;
      displayName: string;
      fields: {
        Message: {
          value: string;
        };
      };
    }[];
  };
  locale: any;
  lang: any;
};

const MoveablePlatform = (props: MoveablePlatformProps): JSX.Element => {
  const [selectedSortOption, setSelectedSortOption] = useState<any>();

  const container = useRef<any>();
  const [sortItemsList, setSortList] = useState<any[]>([]);
  const [moveableListData, setMoveableListData] = useState<MoveablePlatformItem[]>(
    props?.fields?.Rows
  );

  const viewPdf = async (file: any) => {
    const response = await fetch(file.src); // must return application/pdf
    const blob = await response.blob();
    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl, "_blank");
  };

  useEffect(() => {
    setMoveableListData(props?.fields?.Rows);
  }, [props.locale]);

  const sortRows = (sortType: "Oldest" | "Newest", Rows: any[]) => {
    const getDateValue = (row: any) => {
      const dateStr = row.fields?.PostingDate?.value;
      const timestamp = new Date(dateStr).getTime();
      return isNaN(timestamp) ? Infinity : timestamp; // fallback if date is invalid
    };

    return [...Rows].sort((a, b) => {
      const dateA = getDateValue(a);
      const dateB = getDateValue(b);

      return sortType === "Newest" ? dateB - dateA : dateA - dateB;
    });
  };

  useEffect(() => {
    let temp = sortRows(selectedSortOption?.sortValue, props?.fields?.Rows);
    setMoveableListData([...temp]);
  }, [selectedSortOption?.sortValue]);

  useEffect(() => {
    setSortList([]);
    setSortList([
      {
        id: 1,
        name:
          props.locale === "ar"
            ? "الأحدث"
            : props.locale === "zh"
              ? "最新"
              : props.locale === "ko"
                ? "최신순"
                : "Newest",
        sortValue: "Newest",
        unavailable: false,
      },
      {
        id: 2,
        name:
          props.locale === "ar"
            ? "الأقدم"
            : props.locale === "zh"
              ? "最旧"
              : props.locale === "ko"
                ? "오래된순"
                : "Oldest",
        sortValue: "Oldest",
        unavailable: false,
      }
    ]);
    setSelectedSortOption({
      id: 0,
      name: props?.fields?.SortButtonText?.value,
      sortValue: null,
      unavailable: false,
    });
  }, [props?.locale, props]);

  return (
    <>
      <div className="bg-primary-25 py-10">
        <div className="responsive flex md:flex-row flex-col justify-between gap-5">
          <div className="flex flex-col gap-4">
            <h1 className="text-primary-1000 font-semibold md:text-3brand text-4brand">
              {props?.fields?.Title?.value}
            </h1>
            {props?.fields?.Description?.value && (
              <p
                className="text-base w-3/4 "
              // style={{ wordWrap: "break-word", overflowWrap: "break-word", hyphens: "auto" }}
              >
                <RichText field={props?.fields?.Description} />
              </p>
            )}
          </div>

          <div>
            {props?.fields?.Rows?.length > 0 &&
              props?.fields?.ShowPostingDateColumn?.value &&
              props?.fields?.SortButtonText?.value && (
                <div className="md:mt-0 mt-4 max-w-[334px] w-fit flex gap-8 self-end">
                  <div className="relative z-50 w-fit">
                    <DGADropdownInput
                      name='movable-page-sort-dropdown'
                      variant='default'
                      placeholder={selectedSortOption ? selectedSortOption.name : props?.fields?.SortButtonText?.value}
                      InputSize="lg"
                      mainDropdownContainerClassName='max-w-[121px] md:max-w-[250px] w-full'
                      value={selectedSortOption?.id}
                      options={sortItemsList.map((item: any) => ({ ...item, label: item.name, value: item?.id }))}
                      maxHeight={300}
                      closeAfterSelect
                      onChange={(selected) => {
                        if (selected) {
                          const selectedSortItem = sortItemsList.find((item: any) => item?.id === selected);
                          setSelectedSortOption(selectedSortItem);
                        } else {
                          setSelectedSortOption({
                            id: 0,
                            name: props?.fields?.SortButtonText?.value,
                            sortValue: null,
                            unavailable: false,
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              )}
          </div>
        </div>


      </div>
      <section
        ref={container}
        className={`responsive  py-10 min-h-screen overflow-hidden  ${IsRtl() ? "rtl" : "ltr"}`}
      >
        {props?.fields?.Rows?.length > 0 && (
          <div className=" relative mt-8 w-full !min-w-[300px] !overflow-x-auto overflow-y-hidden border border-neutral-300  !rounded-lg">
            <table className="responsive  w-full min-w-full overflow-y-hidden  ">
              <thead>
                <th className="bg-neutral-100 px-2 py-4 text-neutral-700 font-medium text-center  min-w-[50px] animate-top-dga">
                  {props?.fields?.IDColumnTitle?.value}
                </th>
                {props?.fields?.Columns?.length &&
                  props?.fields?.Columns.map((column: any, index: any) => {
                    return (
                      <th
                        key={index}
                        className="bg-neutral-100 animate-top-dga px-2 py-4 text-neutral-700 text-center font-medium border border-t-0  border-neutral-300 min-w-[50px]"
                      >
                        {column?.fields?.Message?.value}
                      </th>
                    );
                  })}
                {props?.fields?.ShowPostingDateColumn?.value && (
                  <th className="animate-top-dga bg-neutral-100 px-2 py-4 text-neutral-700 text-center font-medium border border-t-0 border-neutral-300 min-w-[100px]">
                    {props?.fields?.PostingDateColumnTitle?.value}
                  </th>
                )}
                {props?.fields?.ShowDetailsColumn?.value && (
                  <th className="animate-top-dga bg-neutral-100 px-2 py-4 text-neutral-700 text-center font-medium border border-t-0 border-neutral-300 min-w-[100px]">
                    {props?.fields?.DetailsColumnTitle?.value}
                  </th>
                )}
              </thead>
              <tbody className="mt-2 !overflow-hidden">
                {props?.fields?.Rows?.length &&
                  moveableListData.map((row, index) => (
                    <tr
                      key={index}
                      className="border-b-neutral-300 border-l-0 border-r-0 border-b-0 border-[1px] animate-top-dga overflow-hidden"
                    >
                      <td className="bg-white px-2 py-4 text-primary-1000 text-center">
                        {index + 1}
                      </td>
                      {row.fields?.RowFields?.length &&
                        row?.fields?.RowFields.map((rowField) => (
                          <>
                            {" "}
                            {rowField?.fields?.Type?.fields?.Title?.value === "Text" ? (
                              <td className={` px-2 py-4 bg-white  text-primary-1000 text-center `}>
                                {rowField?.fields?.Title?.value}
                              </td>
                            ) : null}
                            {rowField?.fields?.Type?.fields?.Title?.value === "Date" ? (
                              <td className={`px-2 py-4 bg-white  text-primary-1000 text-center `}>
                                {rowField?.fields?.DateValue?.value !== "0001-01-01T00:00:00Z" ? (
                                  <>
                                    {moment(rowField?.fields?.DateValue?.value)
                                      .locale("en")
                                      .format("D")}{" "}
                                    {moment(rowField?.fields?.DateValue?.value)
                                      .locale(props?.locale)
                                      .format("MMM")}{" "}
                                    {moment(rowField?.fields?.DateValue?.value)
                                      .locale("en")
                                      .format("YYYY")}{" "}
                                  </>
                                ) : (
                                  "---"
                                )}
                              </td>
                            ) : null}
                          </>
                        ))}

                      {props?.fields?.ShowPostingDateColumn?.value ? (
                        <td
                          colSpan={1}
                          className={` px-2 py-4 bg-white  text-primary-1000 text-center `}
                        >
                          {row?.fields?.PostingDate?.value !== "0001-01-01T00:00:00Z" ? (
                            <>
                              {moment(row?.fields?.PostingDate?.value).locale("en").format("D")}{" "}
                              {moment(row?.fields?.PostingDate?.value)
                                .locale(props?.locale)
                                .format("MMM")}{" "}
                              {moment(row?.fields?.PostingDate?.value).locale("en").format("YYYY")}{" "}
                            </>
                          ) : (
                            "---"
                          )}
                        </td>
                      ) : null}
                      {props?.fields?.ShowDetailsColumn?.value ? (
                        <td
                          colSpan={1}
                          className={` px-2 py-4 bg-white  text-primary-1000 text-center flex justify-center `}
                        >
                          {row?.fields?.FileLink?.value ? (
                            <DGAButton
                              variant="secondarySolid"
                              size="lg"
                              onClick={() => viewPdf(row?.fields?.FileLink?.value)}
                              buttonContent={
                                <span className="flex gap-2 items-center">
                                  {props?.fields?.DetailsFieldButtonText?.value}
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http:www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                    <path
                                      d="M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z"
                                      stroke="#161616"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
                                      stroke="#161616"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              }
                            />
                          ) : (
                            "---"
                          )}
                        </td>
                      ) : null}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
};

export default withDatasourceCheck()<MoveablePlatformProps>(MoveablePlatform);

// type MoveablePlatformResponse = {
//     data : {
//     TotalItemsCount: number;
//     MoveablePlatformList:
//         {
//             id: string;
//             moveableList: string;
//             duration: string;
//             location: string;
//             postingDate: string;
//             endingDate: string;
//             contact: string;
//             file: string;
//         }[]
//     }
// }

type MoveablePlatformItem = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    PostingDate: {
      value: string;
    };
    FileLink: {
      value: {
        src: string;
        name: string;
        displayName: string;
        title: string;
        keywords: string;
        description: string;
        extension: string;
        mimeType: string;
      };
    };
    RowFields: {
      id: string;
      url: string;
      name: string;
      displayName: string;

      fields: {
        Type: {
          id: string;
          url: string;
          name: string;
          displayName: string;
          fields: {
            Title: {
              value: string;
            };
          };
        };
        DateValue?: {
          value: string;
        };
        Title?: {
          value: string;
        };
      };
    }[];
  };
};
